export const LEASE = 'lease';
export const FINANCE = 'finance';
export const CASH_PURCHASE = 'cashPurchase';
export const BEST_PAYMENT = 'bestPayment';
export const CASH = 'cash'; // For V2.5 pricing API

export default {
    LEASE,
    FINANCE,
    CASH_PURCHASE,
    BEST_PAYMENT,
    CASH,
};
